
import { defineComponent, PropType } from 'vue'

export interface ILinks {
  label: string
  route?: string
}

/**
 * Container component to render breadcrumb items
 */
export default defineComponent({
  name: 'BreadcrumbContainer',
  props: {
    links: {
      type: Array as PropType<ILinks[]>,
      required: true
    }
  }
})
